import axios from 'axios';
import store from  '../../../index-store';

// export const apiHandle = (apiOptions) => {
//  let response;
//  switch (apiOptions.method) {
//      case 'post': {
//          try {
//              response = axios.post(apiOptions.endpoint, apiOptions.body, apiOptions.config);
//          } catch (ex) {
//              if (ex && ex.response && ex.response.data && ex.response.data) throw ex.response.data.Errors;
//              throw ex;
//          }
//          break;
//      }
//      default:
//          break;
//  }
//  return response;
// };
export const HttpMethod = {
    GET: 'GET',
    POST: 'POST',
    PUT: 'PUT',
    DELETE: 'DELETE',
    OPTIONS: 'OPTIONS',
    HEAD: 'HEAD',
    PATCH: 'PATCH'
};

export class HttpRequest
{
    constructor(method,endpoint,queryParams,body,config) {
        this.method = method;
        this.endpoint = endpoint;
        this.args = [];
        if (queryParams && Array.isArray(queryParams)) {
            this.args = queryParams; 
        } else if (queryParams) {
            this.args.push(queryParams);
        }
        this.url=this.endpoint+((this.args.length>0)?this.args.reduce((acc,curr)=>{return acc=((acc)?'&':'?')+curr;}):'');
        this.body = body;
        this.config = config;
        this.addHeaders();
    }
    
    randomString(length) {
        var charset = '0123456789ABCDEFGHIJKLMNOPQRSTUVXYZabcdefghijklmnopqrstuvwxyz-._'
        let result = ''

        while (length > 0) {
            var bytes = new Uint8Array(16);
            var random = window.crypto.getRandomValues(bytes);

            random.forEach(function(c) {
                if (length === 0) {
                    return;
                }
                if (c < charset.length) {
                    result += charset[c];
                    length--;
                }
            });
        }
        return result;
    }
    
    addHeaders() {
        if (!this.config) this.config = {};
        if (!this.config['headers']) this.config['headers'] = {};
        if (!this.config['headers']['Access-Control-Allow-Origin']) this.config['headers']['Access-Control-Allow-Origin'] = '*';
        if (!this.config['headers']['Content-Type']) this.config['headers']['Content-Type'] = 'application/json';
        if (!this.config['withCredentials']) this.config['withCredentials'] = false;
        if ((!this.config['headers']['X-Request-ID']) &&
            store && store.getState().login && store.getState().login.user_sid)
            this.config['headers']['X-Request-ID'] = this.randomString(4) + "-" + store.getState().login.user_sid;

        // Always add CSRF token from cookie if present
        let csurf = document.cookie.split(';').filter((item) => item.trim().startsWith('_csrf='));
        if (csurf?.length) {
            this.config['headers']['X-CSRF-Token'] = decodeURIComponent(csurf[0].trim().slice('_csrf='.length));
        }
    }
    async addAuthorizationHeaders() {
        // Check if MSAL instance is available and user is authenticated
        if (window.msalInstance) {
            const accounts = window.msalInstance.getAllAccounts();
            if (accounts?.length > 0) {
                try {
                    // Try to acquire token silently
                    const request = {
                        scopes: ["openid", "profile", "User.Read"],
                        account: accounts[0]
                    };
                    const response = await window.msalInstance.acquireTokenSilent(request);
					
                    if (response?.idToken) {
                        // Add both authorization headers
                        this.config['headers']['authorization'] = `Bearer ${response.idToken}`;
                        this.config['headers']['fid-ent-identity-jwt'] = `Bearer ${response.idToken}`;
                    }
                } catch (error) {
                    console.warn('Failed to acquire token for request:', error);
                }
            }
        }
        let csurf = document.cookie.split(';').filter((item) => item.trim().startsWith('_csrf=')) 
        if (csurf?.length) this.config['headers']['X-CSRF-Token'] = decodeURIComponent(csurf[0].trim().slice('_csrf='.length));
	}

    addCSRFHeader() {
        let csurf = document.cookie.split(';').filter((item) => item.trim().startsWith('_csrf=')) 
        if (csurf?.length) this.config['headers']['X-CSRF-Token'] = decodeURIComponent(csurf[0].trim().slice('_csrf='.length));
    }

    async post() {
        try {
            await this.addAuthorizationHeaders();
            return axios.post(this.url, this.body?this.body:{}, this.config)
                    .catch(function (error) {
                        if (error.response) {
                            let errInfo = {error_status: error.response.status};
                            (error.response.data.Errors)
                                ?console.error(error.response.data.Errors,errInfo)
                                :console.error(error.response.data,errInfo);
                        }
                        throw error;
                    });
        } catch (ex) {
            if (ex && ex.response && ex.response.data && ex.response.data) throw ex.response.data.Errors;
            throw ex;
        }       
    }

	async get() {
		try {
			await this.addAuthorizationHeaders();
            if (this.body)
                this.config['params']=this.body;
            return axios.get(this.url, this.config)
                    .catch(function (error) {
                        if (error.response) {
                            let errInfo = {error_status: error.response.status};
                            (error.response.data.Errors)
                                ?console.error(error.response.data.Errors,errInfo)
                                :console.error(error.response.data,errInfo);
                        }
                        throw error;
                    });
        } catch (ex) {
            if (ex && ex.response && ex.response.data && ex.response.data) {
                console.error("Data error present")
                throw ex.response.data.Errors;
            }
            console.error("Data error not present")
            throw ex;
        }       
    }

	async head() {
		try {
			await this.addAuthorizationHeaders();
            return axios.head(this.url, this.config)
                    .catch(function (error) {
                        if (error.response) {
                            let errInfo = {error_status: error.response.status};
                            (error.response.data.Errors)
                                ?console.error(error.response.data.Errors,errInfo)
                                :console.error(error.response.data,errInfo);
                        }
                        throw error;
                    });
        } catch (ex) {
            if (ex && ex.response && ex.response.data && ex.response.data) throw ex.response.data.Errors;
            throw ex;
        }       
    }
    
	async options() {
		try {
			await this.addAuthorizationHeaders();
            return axios.options(this.url, this.config)
                    .catch(function (error) {
                        if (error.response) {
                            let errInfo = {error_status: error.response.status};
                            (error.response.data.Errors)
                                ?console.error(error.response.data.Errors,errInfo)
                                :console.error(error.response.data,errInfo);
                        }
                        throw error;
                    });
        } catch (ex) {
            if (ex && ex.response && ex.response.data && ex.response.data) throw ex.response.data.Errors;
            throw ex;
        }       
    }

	async delete() {
		try {
			await this.addAuthorizationHeaders();
            if (this.body)
                this.config['params']=this.body;            
            return axios.delete(this.url, this.config)
                    .catch(function (error) {
                        if (error.response) {
                            let errInfo = {error_status: error.response.status};
                            (error.response.data.Errors)
                                ?console.error(error.response.data.Errors,errInfo)
                                :console.error(error.response.data,errInfo);
                        }
                        throw error;
                    });
        } catch (ex) {
            if (ex && ex.response && ex.response.data && ex.response.data) throw ex.response.data.Errors;
            throw ex;
        }       
    }
    
	async put() {
		try {
			await this.addAuthorizationHeaders();
            return axios.put(this.url, this.body, this.config)
                    .catch(function (error) {
                        if (error.response) {
                            let errInfo = {error_status: error.response.status};
                            (error.response.data.Errors)
                                ?console.error(error.response.data.Errors,errInfo)
                                :console.error(error.response.data,errInfo);
                        }
                        throw error;
                    });
        } catch (ex) {
            if (ex && ex.response && ex.response.data && ex.response.data) throw ex.response.data.Errors;
            throw ex;
        }       
    }
    
	async patch() {
		try {
			await this.addAuthorizationHeaders();
            return axios.patch(this.url, this.body, this.config)
                    .catch(function (error) {
                        if (error.response) {
                            let errInfo = {error_status: error.response.status};
                            (error.response.data.Errors)
                                ?console.error(error.response.data.Errors,errInfo)
                                :console.error(error.response.data,errInfo);
                        }
                        throw error;
                    });
        } catch (ex) {
            if (ex && ex.response && ex.response.data && ex.response.data) throw ex.response.data.Errors;
            throw ex;
        }       
    }
    
    invoke() {
        switch(this.method) {
        case 'GET':
            return this.get();
        case 'HEAD':
            return this.head();
        case 'OPTIONS':
            return this.options();
        case 'PUT':
            return this.put();
        case 'PATCH':
            return this.patch();
        case 'DELETE':
            return this.delete();
        default:
            return this.post();
        }
    }
        
}

